// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"194":"5be43fda17eda986","809":"120fc94acb38c4d0"}[chunkId] + ".js";
};